<template>
  <chat-window :room="coachRoom" v-if="(user && user.profile && user.profile.allow_messaging) && coachRoom.id" :recipient="recipient" store="ClientMessagingRooms" />
</template>

<script>
import dataStore from "@/services/api/store";
import chatWindow from "@/components/messages";

const MESSAGING_ROOMS_STORE = "ClientMessagingRooms";

export default {
  props: ['user'],
  components: { chatWindow },
  data() {
    return {
      coachRoom: {}
    };
  },
  created() {
    dataStore
      .findAll(MESSAGING_ROOMS_STORE, {}, { force: true })
      .then(rooms => {
        this.coachRoom = rooms[0] || {};
      });
  },
  computed: {
    recipient() {
      if (this.coachRoom.id) {
        return this.coachRoom.users.find(user => user.id !== this.user.id);
      }
      return undefined;
    }
  },
}
</script>

<style>

</style>
